import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import Hero2 from '../../components/Hero/Hero2';
import Medicines from '../../components/Medicines/Medicines';

function MyModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(()=>{
    if(sessionStorage.getItem('modal') !== 'shown'){
      handleShow()
      sessionStorage.setItem('modal', 'shown')
    }
    
  },[])
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>¡Atención!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        La información disponible en esta WebApp está dirigida exclusivamente a profesionales y estudiantes de la salud que cuentan con la debida preparación. 
        </Modal.Body>
      </Modal>
    </>
  );
}


export default function Home() {

  return <div>
      <Header/>
      <Hero/>
      <MyModal/>
      <Medicines/>
      <Hero2/>
      <Footer/>
  </div>;
}
